export const DENSITY_COLUMN = 'area_gross';
